/** Questions answered on the home page. Pricing keeps its own billing questions. */
export const HOME_FAQS = [
    {
        question: 'What does the AI advisor do day to day?',
        answer: 'It links to your accounts, files each transaction under the right category, projects the months ahead and answers money questions in everyday language. It works from your actual balances rather than averages, so asking whether you can afford something gets a clear yes, a no or a plan.'
    },
    {
        question: 'How does Verdane protect my information?',
        answer: 'Everything is encrypted while stored and while moving, account links are read-only, and we never sell your data. Export it or erase it completely whenever you choose.'
    },
    {
        question: 'Could the AI ever move money on its own?',
        answer: 'Never. Verdane can view your balances, but nothing moves until you approve it yourself. Any automatic rule you create can be paused or edited with a single tap.'
    },
    {
        question: 'Can I speak with a human advisor?',
        answer: 'Yes, whenever you need one. Every plan includes a free first call with a certified Verdane advisor, and Private pairs you with a dedicated advisor of your own. Our advisors are salaried and earn no commissions. The AI covers daily questions, and people help with the big ones.'
    },
    {
        question: 'What does Verdane cost?',
        answer: 'Free costs nothing, forever, with no card on file. Plus is $14 a month, or $11 billed yearly, with a 14-day free trial and no card needed. Private, with a dedicated advisor, is $49 a month or $39 billed yearly.'
    },
    {
        question: 'Does it handle income that changes month to month?',
        answer: 'That is exactly what it was made for. Verdane learns your rhythm, turns uneven pay into one steady monthly figure and lets you know weeks in advance when a lean month is on the way.'
    }
]
